export enum GroupByDate {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
  ALL = 'all',
}

export const GROUP_BY_OPTIONS = [
  {
    label: 'Day',
    value: GroupByDate.DAY,
  },
  {
    label: 'Week',
    value: GroupByDate.WEEK,
  },
  {
    label: 'Month',
    value: GroupByDate.MONTH,
  },
  {
    label: 'Year',
    value: GroupByDate.YEAR,
  },
  {
    label: 'All',
    value: GroupByDate.ALL,
  },
];
